import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

export const admin: Routes = [
  {
    path: 'settings',
    children: [
      {
        path: '',
        loadComponent: () => import('./list/settings.component').then((m) => m.SettingsComponent),
      },
    ],
  },
];
@NgModule({
  imports: [RouterModule.forChild(admin)],
  exports: [RouterModule],
})
export class settingsRoutingModule {
  static routes = admin;
}
